import React from 'react';
import { useSelector } from 'react-redux';
import { PasslyButton } from '@app/components';
import { Grid, Box } from '@material-ui/core';

export interface IButtonsData {
    primaryBtn?: string;
    secondaryBtn?: string;
    onClickPrimary?: Function;
    onClickSecondary?: Function;
    disabled?: boolean;
}

export function ModalActionsV2(props: any) {
    const loaderBtnState: boolean = useSelector((state: any) => state.modal.modalLoaderBtn);

    return (
        <Box m={2}>
            <Grid container alignItems='flex-end' justifyContent='flex-end'>
                <Grid item>
                    <Box mr={1}>
                        <PasslyButton additionalColor='tertiary' className='modal__actions-tertiary' onClick={props.onClickSecondary}>
                            {props.secondaryBtn}
                        </PasslyButton>
                    </Box>
                </Grid>
                <Grid item>
                    <PasslyButton
                        onClick={props.onClickPrimary}
                        color='primary'
                        variant='contained'
                        type='button'
                        disabled={props.disabled || loaderBtnState}
                        isLoading={loaderBtnState}
                    >
                        {props.primaryBtn}
                    </PasslyButton>
                </Grid>
            </Grid>
        </Box>
    );
}
